/**
 * Pause HTML5 and YouTube players so only one video plays at a time.
 */
class VideoHelper {
    /**
     * Stop all non-looping HTML5 videos and YouTube players except one.
     *
     * @param {HTMLElement|string|null} [except=null] Element or YouTube player key to keep playing
     */
    static stopAll(except = null) {
        const videos = document.querySelectorAll('video:not([loop])');
        if (videos !== null) {
            for (let i = 0; i < videos.length; i += 1) {
                if (videos[i] !== except) {
                    videos[i].pause();
                }
            }
        }

        if (window.youtubePlayers && Object.keys(window.youtubePlayers).length) {
            Object.keys(window.youtubePlayers).forEach((key) => {
                if (key !== except) {
                    window.youtubePlayers[key].pauseVideo();
                }
            });
        }
    }
}

export default VideoHelper;
